import { fieldRegistry } from './edit-modal/fieldRegistry';
import { FieldDefinition } from './edit-modal/types';
import './edit-modal/registerFields';

export const extractCardDataFromTemplate = (
  sourceCard: any,
  template: { fields: FieldDefinition[] }
): Record<string, any> => {
  const data: Record<string, any> = {};

  template.fields.forEach(field => {
    const rawValue = sourceCard?.[field.name];

    if (rawValue !== null && rawValue !== undefined) {
      if (Array.isArray(rawValue)) {
        data[field.name] = rawValue.filter(
          item => item && (item.mediaUrl || item.url || item.id)
        );
      } else {
        data[field.name] = rawValue;
      }
    }
  });

  return data;
};
